import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageHeader from "@/components/feature/PageHeader";
import WorkCard from "@/components/feature/WorkCard";
import { works } from "@/mocks/works";

export default function NewReleases() {
  const newWorks = [...works].sort((a, b) => {
    const aw = (a.isNew ? 0 : 1) + (a.isExclusive ? 0 : 1);
    const bw = (b.isNew ? 0 : 1) + (b.isExclusive ? 0 : 1);
    return aw - bw;
  });

  return (
    <>
      <Navbar />
      <PageHeader
        crumbs={[
          { label: "首页", to: "/" },
          { label: "新番速递" },
        ]}
        title="新番上架速递"
        desc="叮咚漫画网第一时间上架新作与独家内容，新番抢先看、首发不缺席。以下为近期最新上架的漫画作品。"
      />
      <main className="bg-background-50 py-12 md:py-16">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="mb-6 flex items-center gap-3">
            <span className="flex h-6 w-1 rounded-full bg-primary-500" />
            <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">最新上架</h2>
            <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
              共 {newWorks.length} 部
            </span>
          </div>
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 md:gap-5">
            {newWorks.map((work) => (
              <WorkCard key={work.id} work={work} />
            ))}
          </div>
        </div>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: "叮咚漫画网 新番上架速递",
            description: "叮咚漫画网第一时间上架新作与独家内容，新番抢先看、首发不缺席。",
            url: "https://fangupdate.github.io/new-releases",
            inLanguage: "zh-CN",
            isPartOf: { "@type": "WebSite", name: "叮咚漫画网", url: "https://fangupdate.github.io/" },
          }),
        }}
      />
    </>
  );
}